import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { TableCell, TableRow, IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { RightsContext } from 'providers/RightsContext';

export const DocumentScoringHistoryItemComponent = ({ sessionItem, t, onOpenScoringSessionHistory }) => {
  const { scoringGridAssetRead, scoringGridClientRead, scoringGridDocumentRead } = useContext(RightsContext);

  return (
    <TableRow key={sessionItem.sessionID}>
      <TableCell>{t('DATE_FORMAT', { date: { value: sessionItem.scoringDate, format: 'DD/MMM/YY HH:mm:ss' } })}</TableCell>
      {scoringGridAssetRead && <TableCell>{sessionItem.assetResult}</TableCell>}
      {scoringGridClientRead && <TableCell>{sessionItem.clientResult}</TableCell>}
      {scoringGridDocumentRead && <TableCell>{sessionItem.documentResult}</TableCell>}
      <TableCell align='right'>
        <IconButton
          tooltip={t('OfferEdit.ScoringHistory.ViewHistory')}
          color='primary'
          variant='text'
          size='small'
          onClick={onOpenScoringSessionHistory(sessionItem.documentId, sessionItem.siteId, sessionItem.sessionID)}
        >
          <HistoryIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

DocumentScoringHistoryItemComponent.propTypes = {
  sessionItem: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onOpenScoringSessionHistory: PropTypes.func.isRequired
};

export default compose(withTranslation())(DocumentScoringHistoryItemComponent);
